'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autosuggest/dist/index.js
// module id = 1099
// module chunks = 168707334958949